<template>
  <div ref="inner" :class="['branded-box', `branded-box--${direction}`, centered ? 'branded-box--centered' : '']">
    <slot />
  </div>
</template>

<script>

  export default {

    props: {
      direction: {
        type: String,
        default: 'left',
      },
      centered: {
        type: Boolean,
        default: false,
      }
    },

  }

</script>

<style lang="scss">

  @import "../assets/scss/palette";

  $border: 10px $orange solid;

  .branded-box {
    background-color: transparentize($grey, 0.05);
    color: white;

    &--left {
      border-left: $border;
    }

    &--right {
      border-right: $border;
    }

    &--all {
      border: $border;
    }

    &--centered {
      margin: 0 auto;
    }

    p {
      margin-bottom: 1rem;
    }
  }

</style>